/* eslint-disable react-hooks/exhaustive-deps */
import { Affix, Button, Checkbox, Form, Input, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import {
    ExclamationCircleOutlined,
    PlusCircleOutlined,
} from '@ant-design/icons';
import PolicyService from '../../../../services/Policy.service';
import { useBlocker } from '../../../../util/usePrompt';
import useNotify from '../../../../context/Notification/useNotify';
import { useNavigate, useParams } from 'react-router-dom';
import ModalDiscardChanges from '../../../../components/Shared/modal/discardChanges';
import DataFlowService from '../../../../services/DataFlow.service';
import ModalConfirm from '../../../../components/Shared/modal/confirm';
import { ROUTER } from '../../../../constants/router';

const Tab2 = ({ categoryPersonalData, getDataFlowDetail }) => {
    const { t, i18n } = useTranslation();
    const { businessProcessId } = useParams();
    const [form] = Form.useForm();
    const [personalDataOption, setPersonalDataOption] = useState([]);
    const [sensitivePersonalDataOption, setSensitivePersonalDataOption] =
        useState([]);
    const lang = i18n.language;

    const personalDataAddOn = Form.useWatch('personalDataAddOn', form);

    // Confirm
    const [openConfirm, setOpenConfirm] = useState(false);
    const [valueSave, setValueSave] = useState();
    const [loading, setLoading] = useState(false);

    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);

    const Navigate = useNavigate();
    const notify = useNotify();

    useBlocker((nextLocation) => onChangePage(nextLocation), change === true);

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };

    const handelOk = async () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        setOpenChange(false);
        setChange(false);
        setIsChangeLocation(false);
        await form.resetFields();
        await Navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
        await getDataFlowDetail(businessProcessId);
    };

    useEffect(() => {
        const getPersonalDataOption = async () => {
            const { data } = await PolicyService.getPersonalDataOption();
            if (data.resultData) {
                setPersonalDataOption(data.resultData);
            }
        };
        const getSensitivePersonalDataOption = async () => {
            const { data } =
                await PolicyService.getSensitivePersonalDataOption();
            if (data.resultData) {
                setSensitivePersonalDataOption(data.resultData);
            }
        };
        getPersonalDataOption();
        getSensitivePersonalDataOption();
    }, []);

    const onSubmit = async () => {
        try {
            const { data } = await DataFlowService.updateTab2({
                businessProcessId: businessProcessId,
                categoryPersonalData: {
                    ...valueSave,
                    categoryPersonalDataId:
                        categoryPersonalData?.categoryPersonalDataId,
                },
            });
            if (data?.resultCode === 1) {
                notify({
                    title: t('common.Success'),
                    description: t('common.SaveData'),
                });
                setOpenConfirm(false);
                setOpenChange(false);
                setChange(false);
                getDataFlowDetail(businessProcessId);
                setLoading(false);
                changePage();
            } else {
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submitted'),
                });
                setOpenConfirm(false);
            }
        } catch (error) {
            console.log(error);
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to submitted'),
            });
            setOpenConfirm(false);
        }
    };

    const changePage = () => {
        Navigate(
            `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}/view?tab=2&mode=view`
        );
    };

    useEffect(() => {
        if (categoryPersonalData) {
            let personalDataAddOn = [],
                sensitiveDataAddOn = [];
            for (let cate of categoryPersonalData?.personalDataAddOn) {
                personalDataAddOn.push({
                    personalDataAddOnId: cate?.personalDataOptionAddOnId,
                    personalDataAddOnName: cate?.personalDataOptionAddOnName,
                });
            }
            for (let cate of categoryPersonalData?.sensitiveDataAddOn) {
                sensitiveDataAddOn.push({
                    sensitiveDataAddOnId:
                        cate?.sensitivePersonalDataOptionAddOnId,
                    sensitiveDataAddOnName:
                        cate?.sensitivePersonalDataOptionAddOnName,
                });
            }

            form.setFieldsValue({
                ...categoryPersonalData,
                personalData: categoryPersonalData?.personalData?.map(
                    (e) => e.id
                ),
                sensitiveData: categoryPersonalData?.sensitiveData?.map(
                    (e) => e.id
                ),
                personalDataTopic: categoryPersonalData?.personalDataTopic,
                personalDataAddOn,
                sensitiveDataAddOn,
            });
        }
    }, [categoryPersonalData]);

    return (
        <>
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                layout="vertical"
                form={form}
                onFinish={(value) => {
                    setOpenConfirm(true);
                    setValueSave(value);
                }}
                onFieldsChange={(_, allFields) => {
                    if (allFields.length > 0) {
                        setChange(true);
                    }
                }}
            >
                <Affix offsetTop={60}>
                    <div className="flex justify-end space-x-3">
                        <Button
                            hidden={!categoryPersonalData}
                            size="large"
                            type="default"
                            className="text-purple-PHX border-purple-PHX w-32"
                            onClick={changePage}
                        >
                            {t('common.Cancel')}
                        </Button>
                        <Button
                            size="large"
                            type="primary"
                            className="w-32"
                            htmlType="submit"
                        >
                            {t('common.Save')}
                        </Button>
                    </div>
                </Affix>
                <span className="ant-col ant-form-item-label mt-4">
                    <label className="ant-form-item-required">
                        <>
                            <span className="text-[21px] font-bold">
                                {t('dataFlow.TypePersonalData')}
                            </span>
                            <Tooltip
                                placement="right"
                                overlayClassName="min-w-[320px]"
                                title={
                                    <div
                                        className="whitespace-pre-line"
                                        dangerouslySetInnerHTML={{
                                            __html: t(
                                                'dataFlow.TypePersonalDataTooltip'
                                            ),
                                        }}
                                    ></div>
                                }
                            >
                                <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple ml-2">
                                    <ExclamationCircleOutlined />
                                </a>
                            </Tooltip>
                        </>
                    </label>
                </span>
                <Form.Item
                    // className="mt-2"
                    name="personalData"
                    rules={[
                        {
                            required:
                                personalDataAddOn?.length === 0 ||
                                personalDataAddOn === undefined,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Checkbox.Group className="w-full">
                        <div
                            style={{ background: '#F4F6FC' }}
                            className="p-4 rounded-md mt-4"
                        >
                            <div className="text-sm font-semibold">
                                {t('policy.personalDataOption')}
                            </div>
                            {personalDataOption.map((is) => {
                                return (
                                    <div key={is.personalDataOptionId}>
                                        <Checkbox
                                            key={is.personalDataOptionId}
                                            value={is.personalDataOptionId}
                                            style={{ lineHeight: '32px' }}
                                        >
                                            {lang === 'en'
                                                ? is.personalDataOptionEn
                                                : is.personalDataOptionTh}
                                        </Checkbox>
                                        <br />
                                    </div>
                                );
                            })}
                            <Form.List name="personalDataAddOn">
                                {(fields, { add, remove }, index) => (
                                    <>
                                        <div
                                            key={index}
                                            style={{ background: '#EEE5FF' }}
                                            className="px-4 rounded-md mt-2"
                                        >
                                            {fields.map(
                                                (
                                                    { key, name, ...restField },
                                                    i
                                                ) => (
                                                    <div
                                                        key={key}
                                                        className="flex first:pt-2"
                                                    >
                                                        <Form.Item
                                                            className="mb-2 w-full"
                                                            {...restField}
                                                            name={[
                                                                name,
                                                                'personalDataAddOnName',
                                                            ]}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: t(
                                                                        'errorText.requiredField'
                                                                    ),
                                                                },
                                                                {
                                                                    max: 100,
                                                                    message: t(
                                                                        'This field must be between 1 and 100 characters'
                                                                    ),
                                                                },
                                                            ]}
                                                        >
                                                            <Input
                                                                placeholder={t(
                                                                    'dataFlow.inputpl'
                                                                )}
                                                                size="large"
                                                                className="pr-12 bg-white"
                                                            />
                                                        </Form.Item>
                                                        <div
                                                            className="cursor-pointer hover:opacity-80 absolute right-0 p-1 pr-10"
                                                            onClick={() =>
                                                                remove(name)
                                                            }
                                                        >
                                                            {DeleteIcon}
                                                        </div>
                                                    </div>
                                                )
                                            )}
                                        </div>
                                        <Form.Item className="mb-0">
                                            <span
                                                className="text-blue-400 hover:opacity-80 cursor-pointer font-semibold"
                                                onClick={() => add()}
                                            >
                                                <PlusCircleOutlined />{' '}
                                                {t('common.addOption')}
                                            </span>
                                        </Form.Item>
                                    </>
                                )}
                            </Form.List>
                        </div>
                    </Checkbox.Group>
                </Form.Item>
                <Form.Item
                    className="mt-4"
                    name={'sensitiveData'}
                    // label={
                    //     <span className="text-[21px] font-bold">
                    //         {t('policy.personalData')}
                    //     </span>
                    // }
                >
                    <Checkbox.Group className="w-full">
                        <div
                            style={{ background: '#F4F6FC' }}
                            className="p-4 rounded-md mt-4"
                        >
                            <div className="text-sm font-semibold">
                                {t('policy.sensitivePersonalDataOption')}
                            </div>
                            {sensitivePersonalDataOption.map((is) => {
                                return (
                                    <div key={is.sensitivePersonalDataOptionId}>
                                        <Checkbox
                                            key={
                                                is.sensitivePersonalDataOptionId
                                            }
                                            value={
                                                is.sensitivePersonalDataOptionId
                                            }
                                            style={{ lineHeight: '32px' }}
                                        >
                                            {lang === 'en'
                                                ? is.sensitivePersonalDataOptionEn
                                                : is.sensitivePersonalDataOptionTh}
                                        </Checkbox>
                                        <br />
                                    </div>
                                );
                            })}
                            <Form.List name="sensitiveDataAddOn">
                                {(fields, { add, remove }, index) => (
                                    <>
                                        <div
                                            key={index}
                                            style={{ background: '#EEE5FF' }}
                                            className="px-4 rounded-md mt-2"
                                        >
                                            {fields.map(
                                                (
                                                    { key, name, ...restField },
                                                    i
                                                ) => (
                                                    <div
                                                        key={key}
                                                        className="flex first:pt-2"
                                                    >
                                                        <Form.Item
                                                            className="mb-2 w-full"
                                                            {...restField}
                                                            name={[
                                                                name,
                                                                'sensitiveDataAddOnName',
                                                            ]}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: t(
                                                                        'errorText.requiredField'
                                                                    ),
                                                                },
                                                                {
                                                                    max: 100,
                                                                    message: t(
                                                                        'This field must be between 1 and 100 characters'
                                                                    ),
                                                                },
                                                            ]}
                                                        >
                                                            <Input
                                                                placeholder={t(
                                                                    'dataFlow.inputpl'
                                                                )}
                                                                size="large"
                                                                className="pr-12 bg-white"
                                                            />
                                                        </Form.Item>
                                                        <div
                                                            className="cursor-pointer hover:opacity-80 absolute right-0 p-1 pr-10"
                                                            onClick={() =>
                                                                remove(name)
                                                            }
                                                        >
                                                            {DeleteIcon}
                                                        </div>
                                                    </div>
                                                )
                                            )}
                                        </div>
                                        <Form.Item className="mb-0">
                                            <span
                                                className="text-blue-400 hover:opacity-80 cursor-pointer font-semibold"
                                                onClick={() => add()}
                                            >
                                                <PlusCircleOutlined />{' '}
                                                {t('common.addOption')}
                                            </span>
                                        </Form.Item>
                                    </>
                                )}
                            </Form.List>
                        </div>
                    </Checkbox.Group>
                </Form.Item>
                <Form.List name="personalDataTopic">
                    {(fields, { add, remove }) => (
                        <>
                            {fields.map((field, i) => (
                                <div
                                    key={field.key}
                                    style={{ background: '#F4F6FC' }}
                                    className="px-4 pb-0.5 pt-2 rounded-md mt-2 ml-6"
                                >
                                    <div className="flex items-center">
                                        <div className="text-sm font-semibold flex-1">
                                            {t('policy.exData2')} {i + 1}
                                        </div>
                                        <div
                                            className="cursor-pointer hover:opacity-80"
                                            onClick={() => remove(field.name)}
                                        >
                                            {DeleteIcon2}
                                        </div>
                                    </div>
                                    <Form.Item
                                        className="mb-2"
                                        {...field}
                                        name={[
                                            field.name,
                                            'personalDataTopicName',
                                        ]}
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'errorText.requiredField'
                                                ),
                                            },
                                            {
                                                max: 100,
                                                message: t(
                                                    'This field must be between 1 and 100 characters'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder={t('dataFlow.inputpl')}
                                            size="large"
                                            className="pr-12 bg-white"
                                        />
                                    </Form.Item>
                                    <Form.List
                                        name={[
                                            field.name,
                                            'personalDataTopicOption',
                                        ]}
                                    >
                                        {(
                                            personalDataTopicOption,
                                            { add, remove }
                                        ) => (
                                            <>
                                                {personalDataTopicOption.map(
                                                    (subfield, j) => (
                                                        <div
                                                            key={subfield.key}
                                                            style={{
                                                                background:
                                                                    '#EEE5FF',
                                                            }}
                                                            className="px-4 pb-0.5 pt-2 rounded-md mt-2"
                                                        >
                                                            <div className="flex items-center">
                                                                <div className="text-sm font-semibold flex-1">
                                                                    {t(
                                                                        'dataFlow.ExampleData'
                                                                    )}{' '}
                                                                    {j + 1}
                                                                </div>
                                                                <div
                                                                    className="cursor-pointer hover:opacity-80"
                                                                    onClick={() =>
                                                                        remove(
                                                                            subfield.name
                                                                        )
                                                                    }
                                                                >
                                                                    {DeleteIcon}
                                                                </div>
                                                            </div>
                                                            <Form.Item
                                                                className="mb-2"
                                                                {...subfield}
                                                                name={[
                                                                    subfield.name,
                                                                    'personalDataTopicOptionName',
                                                                ]}
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message:
                                                                            t(
                                                                                'errorText.requiredField'
                                                                            ),
                                                                    },
                                                                    {
                                                                        max: 100,
                                                                        message:
                                                                            t(
                                                                                'This field must be between 1 and 100 characters'
                                                                            ),
                                                                    },
                                                                ]}
                                                            >
                                                                <Input
                                                                    placeholder={t(
                                                                        'dataFlow.inputpl'
                                                                    )}
                                                                    size="large"
                                                                    className="pr-12 bg-white"
                                                                />
                                                            </Form.Item>
                                                        </div>
                                                    )
                                                )}
                                                <Form.Item className="mb-0">
                                                    <span
                                                        className="px-2 text-blue-400 hover:opacity-80 cursor-pointer"
                                                        onClick={() => add()}
                                                    >
                                                        <PlusCircleOutlined />{' '}
                                                        {t('policy.addOption')}
                                                    </span>
                                                </Form.Item>
                                            </>
                                        )}
                                    </Form.List>
                                </div>
                            ))}
                            <Form.Item className="mb-0 mt-2">
                                <span
                                    className="text-blue-400 hover:opacity-80 cursor-pointer"
                                    onClick={() => add()}
                                >
                                    <PlusCircleOutlined />{' '}
                                    {t('policy.addOption2')}
                                </span>
                            </Form.Item>
                        </>
                    )}
                </Form.List>
            </Form>
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
            <ModalConfirm
                loading={loading}
                text={t('Do you want to confirm')}
                open={openConfirm}
                handelOk={onSubmit}
                handelClose={() => setOpenConfirm(false)}
            />
        </>
    );
};

export default Tab2;

const DeleteIcon = (
    <svg
        width={32}
        height={32}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width={32} height={32} rx={6} fill="#F3F6F9" />
        <path
            d="M15.9998 9C16.5487 8.99992 17.0778 9.20504 17.4832 9.57509C17.8887 9.94513 18.1411 10.4534 18.191 11H21.5998C21.7518 11 21.8982 11.0578 22.0092 11.1616C22.1203 11.2654 22.1879 11.4074 22.1982 11.5591C22.2086 11.7108 22.161 11.8607 22.0651 11.9786C21.9691 12.0966 21.832 12.1737 21.6814 12.1944L21.5998 12.2H21.1334L20.1198 20.984C20.0747 21.3739 19.8878 21.7336 19.5947 21.9947C19.3016 22.2558 18.9227 22.4001 18.5302 22.4H13.4694C13.0769 22.4001 12.698 22.2558 12.4049 21.9947C12.1118 21.7336 11.9249 21.3739 11.8798 20.984L10.8654 12.2H10.3998C10.2548 12.2 10.1147 12.1475 10.0055 12.0522C9.89619 11.9569 9.82512 11.8252 9.8054 11.6816L9.7998 11.6C9.79981 11.455 9.85232 11.3149 9.94762 11.2057C10.0429 11.0964 10.1746 11.0253 10.3182 11.0056L10.3998 11H13.8086C13.8585 10.4534 14.1109 9.94513 14.5164 9.57509C14.9218 9.20504 15.4509 8.99992 15.9998 9ZM14.7998 14C14.6038 14 14.4398 14.124 14.4062 14.2872L14.3998 14.3504V19.2504L14.4062 19.3128C14.4398 19.476 14.6038 19.6 14.7998 19.6C14.9958 19.6 15.1598 19.476 15.1934 19.3128L15.1998 19.2496V14.3512L15.1934 14.2872C15.1598 14.1248 14.9958 14 14.7998 14ZM17.1998 14C17.0038 14 16.8398 14.124 16.8062 14.2872L16.7998 14.3504V19.2504L16.8062 19.3128C16.8398 19.476 17.0038 19.6 17.1998 19.6C17.3958 19.6 17.5598 19.476 17.5934 19.3128L17.5998 19.2496V14.3512L17.5934 14.2872C17.5598 14.1248 17.3958 14 17.1998 14ZM15.9998 10.2C15.5158 10.2 15.1118 10.544 15.0198 11H16.9798C16.887 10.544 16.4838 10.2 15.9998 10.2Z"
            fill="#7B67FB"
        />
    </svg>
);

const DeleteIcon2 = (
    <svg
        width={32}
        height={32}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width={32} height={32} rx={6} fill="#EEE5FF" />
        <path
            d="M16 9C16.549 8.99992 17.0781 9.20504 17.4835 9.57509C17.8889 9.94513 18.1413 10.4534 18.1912 11H21.6C21.7521 11 21.8984 11.0578 22.0095 11.1616C22.1206 11.2654 22.1881 11.4074 22.1985 11.5591C22.2088 11.7108 22.1612 11.8607 22.0653 11.9786C21.9694 12.0966 21.8322 12.1737 21.6816 12.1944L21.6 12.2H21.1336L20.12 20.984C20.0749 21.3739 19.888 21.7336 19.5949 21.9947C19.3018 22.2558 18.923 22.4001 18.5304 22.4H13.4696C13.0771 22.4001 12.6983 22.2558 12.4052 21.9947C12.1121 21.7336 11.9252 21.3739 11.88 20.984L10.8656 12.2H10.4C10.2551 12.2 10.115 12.1475 10.0057 12.0522C9.89643 11.9569 9.82537 11.8252 9.80565 11.6816L9.80005 11.6C9.80005 11.455 9.85256 11.3149 9.94786 11.2057C10.0432 11.0964 10.1748 11.0253 10.3184 11.0056L10.4 11H13.8088C13.8587 10.4534 14.1112 9.94513 14.5166 9.57509C14.922 9.20504 15.4511 8.99992 16 9ZM14.8 14C14.604 14 14.44 14.124 14.4064 14.2872L14.4 14.3504V19.2504L14.4064 19.3128C14.44 19.476 14.604 19.6 14.8 19.6C14.996 19.6 15.16 19.476 15.1936 19.3128L15.2 19.2496V14.3512L15.1936 14.2872C15.16 14.1248 14.996 14 14.8 14ZM17.2 14C17.004 14 16.84 14.124 16.8064 14.2872L16.8 14.3504V19.2504L16.8064 19.3128C16.84 19.476 17.004 19.6 17.2 19.6C17.396 19.6 17.56 19.476 17.5936 19.3128L17.6 19.2496V14.3512L17.5936 14.2872C17.56 14.1248 17.396 14 17.2 14ZM16 10.2C15.516 10.2 15.112 10.544 15.02 11H16.98C16.8872 10.544 16.484 10.2 16 10.2Z"
            fill="#7B67FB"
        />
    </svg>
);
